import '../../Default.css'
import './Book.css'
import { Flex, Radio } from "antd";
import { FC, useContext, useState } from "react";
import { BookForm } from './BookForm';
import { CheckboxGroupProps } from 'antd/es/checkbox';
import { ResponsiveContext } from '../../context/responsive-context';

type FormType = 'book' | 'giftcard' | 'company'

export type BookFormProps = {
  selectedForm: FormType
}

export const Book: FC = () => {
  const { useVertical, isMobile } = useContext(ResponsiveContext)
  const [ showForm, setShowForm ] = useState(false)
  const [ selectedForm, setSelectedForm ] = useState('' as FormType)

  const options: CheckboxGroupProps<string>['options'] = [
    { label: 'Időpontfoglalás', value: 'book' },
    { label: 'Ajándékkártya', value: 'giftcard' },
    { label: 'Cégeknek', value: 'company' },
  ];

  const containerStyle = () => {
    let st: React.CSSProperties = {}
    if (!showForm) {
      st.minHeight = '100vh'
    }
    if (isMobile) {
      st.backgroundPositionX = showForm ? -500 : -200
    }
    return st
  }

  return (
    <div id="book" className={isMobile ? "Default-container Book-container-mobile" : "Default-container Book-container"}
    style={containerStyle()}
    >
     <Flex vertical style={{height: '100%', paddingTop: 10}} justify={ showForm ? 'start' : 'center'}>
       <Flex className="Book-message-type-container" justify={'space-evenly'}>
        <Radio.Group
          block
          options={options}
          optionType="button"
          buttonStyle="outline"
          onChange={(props) => {
            setSelectedForm(props.target.value)
            setShowForm(true)

          }}
        />
        </Flex>
        {showForm &&
          <BookForm
            selectedForm={selectedForm}
          />
        }
    </Flex>
  </div>
  )
}
